import React from "react";
import { USD } from "../../../utils/helpers";
import { motion } from "framer-motion";
export default class Step1 extends React.Component {
    render() {
        const { meals, handleChange } = this.props;
        //@ts-ignore: This is passed through
        const nextStep = this.props.nextStep;
        return (React.createElement("div", { className: "card card-body plan-card" },
            React.createElement("p", null, "To begin please select the meal plan you'd like to order."),
            React.createElement(motion.div, { className: "row", initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { delay: 0.5 } }, meals.map((meal, idx) => (React.createElement(React.Fragment, { key: idx },
                React.createElement("div", { className: "col-md" },
                    React.createElement("h2", { className: "text-center h4" }, meal.name),
                    meal.variants.map((variant, idx2) => (React.createElement("div", { className: "form-check custom-check active", key: idx2 },
                        React.createElement("input", { className: "form-check-input", type: "radio", name: "id", id: variant.sku, value: variant.id, onChange: (e) => handleChange(e, "meal", nextStep) }),
                        React.createElement("label", { className: "form-check-label", htmlFor: variant.sku },
                            React.createElement("span", { className: "custom-check-text" }, variant.size),
                            React.createElement("span", { className: "price" }, USD(variant.price).format()))))))))))));
    }
}
